module.exports = __webpack_public_path__ + "static/img/welcome-text-2.16339e2.png";